export { default as Angle1 } from './angle-1';
export { default as Angle2 } from './angle-2';
export { default as Angle3 } from './angle-3';
export { default as Angle4 } from './angle-4';
export { default as Angle5 } from './angle-5';
export { default as Angle6 } from './angle-6';
export { default as AudioOff } from './audio-off';
export { default as Audio } from './audio';
export { default as AutoSkip } from './auto-skip';
export { default as Backward5Sec } from './backward-5-sec';
export { default as EnterFullscreen } from './enter-fullscreen';
export { default as ExitFullscreen } from './exit-fullscreen';
export { default as FastForward } from './fast-forward';
export { default as Forward5Sec } from './forward-5-sec';
export { default as LoopOff } from './loop-off';
export { default as Loop } from './loop';
export { default as Next } from './next';
export { default as NormalPlay } from './normal-play';
export { default as Pause } from './pause';
export { default as Play } from './play';
export { default as Previous } from './previous';
export { default as Replay } from './replay';
export { default as Rewind } from './rewind';
export { default as SlowBackward } from './slow-backward';
export { default as SlowForward } from './slow-forward';



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/index.js